module.exports = __webpack_public_path__ + "img/I_TalkBeforeAction.3a36bbdd.gif";